export function importAll(modules: Record<string, { default: string }>) {
  // Sort the modules by filename to ensure consistent order
  const sortedEntries = Object.entries(modules).sort(([a], [b]) => a.localeCompare(b));
  return sortedEntries.map(([_, module]) => module.default);
}